import React from 'react';
import { Button } from 'primereact/button';
import { useFileManagerContext } from 'modules/file_manager/context/FileManagerContext';

function CreateFolderButton() {
  const { modals } = useFileManagerContext();
  return <Button label="Create Folder" className="p-button p-button-primary" onClick={() => modals.setShowCreateFolderModal(true)} />;
}

export default CreateFolderButton;
